<template>
  <div class="map-container mt-5 mt-md-0" ref="mapContainer"></div>
  <!-- Elemento para el popup -->
  <div id="popup" class="ol-popup" ref="popupContainer">
    <a
      href="#"
      id="popup-closer"
      class="ol-popup-closer"
      @click.prevent="closePopup"
    ></a>
    <div id="popup-content" ref="popupContent"></div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { onMounted, ref, watch } from "vue";
import {
  createMap,
  createMarkersJornadas,
  loadMapDataJornadas,
  createPopup,
  addMapClickEvent,
  fitMapToFeaturesJornadas,
} from "../../services/mapService";

import { useRoute } from "vue-router";
import { get_ficha_jornada } from "@/lib/peticiones_jornadas_api";

const route = useRoute();
const mapContainer = ref(null);
const popupContainer = ref(null);
const popupContent = ref(null);
const map = ref(null);
const popup = ref(null);
const { nombre_seo_jornada } = route.params;
const idIdioma = ref("");
const jornada = ref({});

function closePopup() {
  popup.value.setPosition(undefined);
}

onMounted(async () => {
  let idioma_seleccionado = localStorage.getItem("idioma_seleccionado");
  idIdioma.value = idioma_seleccionado === "es" ? 1 : 2;
  // Inicializar el mapa
  map.value = createMap(mapContainer.value);
  obtener_datos_del_mapa(idIdioma, nombre_seo_jornada);
  
});

watch(
  () => route.params.nombre_seo_jornada,
  async (nuevo_nombre_seo_jornada) => {
    obtener_datos_del_mapa(idIdioma, nuevo_nombre_seo_jornada);
    // TODO NO SE SI ESTÁ BIEN
    //location.reload();
  }
);



const obtener_datos_del_mapa = async (idIdioma, nombre_seo_jornada) => {
  try {
    // Obtener los datos del mapa utilizando el servicio externo
    const { data } = await get_ficha_jornada(
      idIdioma.value,
      nombre_seo_jornada
    );

    // Cargar los datos del mapa desde la respuesta
    const { alojamientos, restaurantes } = loadMapDataJornadas(data);


    // Crear y añadir los marcadores al mapa
    
    const { features, vectorSource } = createMarkersJornadas(
      map.value,
      alojamientos,
      restaurantes
    );

    // Ajustar el mapa para que incluya todos los marcadores
    fitMapToFeaturesJornadas(map.value, features);

    // Crear el popup y añadirlo al mapa
    popup.value = createPopup(popupContainer.value);

    map.value.addOverlay(popup.value);

    // Añadir evento de clic para mostrar información
    addMapClickEvent(map.value, popup.value, (properties) => {
      
      // Actualizar el contenido del popup
      popupContent.value.innerHTML = `<a href="/jornada/${nombre_seo_jornada}/${
        properties.nombre_seo_participante
      }"
        class='link-dark icono_participante'>
          <p class="mb-1 fw-bold">${properties.name}</p>
          <p class="mb-1">${properties.address} - ${properties.city}</p>
          ${
            properties.img
              ? `<img src="${properties.img}" alt="${properties.name}" style="width:100px;height:auto;">`
              : ""
          }
              </a>
        `;
    });
    
  } catch (error) {
    console.error("Error al cargar los datos del mapa:", error);
  }
};


</script>

<style scoped>

.map-container {
  width: 100%;
  height: 100%;
}


/* Estilos para el popup */
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  min-width: 200px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48%;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48%;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
  color: #000;
}

.ol-popup-closer:after {
  content: "✖";
}

</style>
